import { render, staticRenderFns } from "./WidgetTreeSlot.vue?vue&type=template&id=4787a35c&scoped=true&"
import script from "./WidgetTreeSlot.vue?vue&type=script&lang=js&"
export * from "./WidgetTreeSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4787a35c",
  null
  
)

export default component.exports